import React from "react";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

import {
	CardsWrapper,
	StudentsWrapper,
	Container,
	Image,
	Title,
	SubTitile,
	SubHeading,
	Heading,
} from "./style";

const Students = (props) => {
	const { header, cards } = props;
	return (
		<StudentsWrapper>
			<Heading>{header}</Heading>
			<CardsWrapper>
				{cards.map((card, index) => (
					<Container key={index}>
						<a
							href={card?.studentPageURL?.link}
							target={card?.studentPageURL?.target}
						>
							<Image>
								<CloudinaryImage
									url={card?.avatar?.image}
									quality="auto"
									lazyload
									fetchFormat="auto"
									sizes={{
										default: {
											height: 121,
										},
									}}
									alt={card?.avatar?.altTag}
								/>
							</Image>
							<Title>{card?.title}</Title>
							<SubTitile>{card?.subtitle}</SubTitile>
							<SubHeading>{card?.subHeading}</SubHeading>
						</a>
					</Container>
				))}
			</CardsWrapper>
		</StudentsWrapper>
	);
};

Students.propTypes = {
	header: PropTypes.string,
	cards: PropTypes.array,
};

Students.defaultProps = {
	header: "",
	cards: [],
};

export default Students;
